import { Injectable, TemplateRef } from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';
import { Observable, Subject } from 'rxjs';

export type ToastType = 'basic' | 'error' | '' | 'success';

export interface Toast {
  template?: TemplateRef<{}>;
  type?: ToastType;
  message?: string;
  icon?: IconComponent.Name;
  duration: number;
}

export type UpdateToastData =
  | {
      message: string | undefined;
      linkText?: string;
      duration: number;
      erred: boolean;
      count: number;
      linkEmitValue?: string;
    }
  | {
      linkText?: string;
      linkEmitValue?: string;
      erred: true;
      message: string;
      count: number;
    };

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toast = new Subject<Toast>();
}

@Injectable()
export class ToastEventBus {
  private subject = new Subject<UpdateToastData | undefined>();

  emit(event: UpdateToastData | undefined) {
    this.subject.next(event);
  }

  on(): Observable<UpdateToastData | undefined> {
    return this.subject.asObservable();
  }
}
